<template>
  <b-container id="maindiv">
    <section>
      <b-row>
        <div class="col-md-12">
          <h2>{{$lang('aproposal')}}</h2>
          <!-- <p class="my-3">{{$lang('description')}}</p> -->
        </div>
      </b-row>
    </section>

    <section id="mainsection">
      <div id="content">
        <div v-if="wait" class="text-center text-muted my-5">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <div v-if="error" class="text-center text-muted my-2">
          <b-alert show variant="danger">{{error}}</b-alert>
        </div>

        <b-row v-if="loaded">
          <div class="col-md-9">
            <div class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('details')}}</p>
              <b-list-group class="ml-1">
                <b-list-group-item class="d-flex justify-content-between align-items-center first-inverted">
                  {{$lang('atype')}}
                  <span class="font-weight-bold">{{doc.data.vacationtype}}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('date')}}
                  <span class="font-weight-bold">{{doc.data.dbeg}}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('todate')}}
                  <span class="font-weight-bold">{{doc.data.dend}}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('ptype')}}
                  <span class="font-weight-bold">{{doc.data.periodtype}}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('sabegin')}}
                  <span class="font-weight-bold">{{doc.data.shortstart}}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('saduration')}}
                  <span class="font-weight-bold">{{doc.data.shortduration}}</span>
                </b-list-group-item>
                <b-list-group-item v-show="isEmCase" class="d-flex justify-content-between align-items-center">
                  {{$lang('emcase')}}
                  <span class="font-weight-bold">{{doc.data.emcase}}</span>
                </b-list-group-item>
                <b-list-group-item v-if="isSpecLeaveType" class="d-flex justify-content-between align-items-center">
                  {{$lang('specialleavetype')}}
                  <span class="font-weight-bold">{{doc.data.p_spleave_ol}}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('remark')}}
                  <span class="ml-3 font-weight-bold">{{doc.data.remark}}</span>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('dochistory')}}</p>
              <ul class="timeline">
                  <li class="media" v-for="one in doc.history" v-bind:key="one.id" v-bind:style="{'border-color': one.s_sclr}">
                    <div class="media-body">
                      <h6 class="font-weight-bold">{{one.state}}</h6>
                      <span>{{one.dd}}</span>
                      <span class="ml-3" >{{one.username}}</span>
                      <p class="mt-1">{{one.remark}}</p>
                    </div>
                  </li>
              </ul>
            </div>
            <div v-if="showCancelations" class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('cancelations')}}</p>
              <div v-if="hasCancelations" class="pb-2">
                <b-table-lite striped outlined borderless  hover head-variant="dark" stacked="md" primary-key="id" :fields="canFields" :items="doc.cancelations.list">
                  <template slot="s_s" slot-scope="row">
                    <div class="state">
                      <i class="fa fa-circle-o mr-1" v-bind:style="{'color': row.item.s_sclr}"></i>{{row.item.s_s}}
                    </div>
                  </template>   
                  <template slot="agreeactions" slot-scope="row">
                    <div v-if="row.item.agreeactions">
                      <b-button class="mb-1" variant="success" size="sm" @click="doAskAction('qagree',row.item.id,1000236)">{{$lang('agree')}}</b-button>
                      <b-button class="mb-1" variant="danger" size="sm" @click="doAskAction('qdisagree',row.item.id,1000237)">{{$lang('disagree')}}</b-button>
                    </div>
                  </template>
                </b-table-lite>
              </div>
              <b-button variant="secondary" @click="doNewCancel()">{{$lang("newcancel")}}</b-button>
            </div>
          </div>
          <div class="col-md-3">
            
            <div v-if="hasActions" class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('actions')}}</p>
              <b-button class="mb-3 mr-3 actionbutton" v-for="one in doc.actions" v-bind:key="one.oid" @click="doAction(one)" :variant="one.variant">
                <span class="m-1">{{one.caption}}</span>
                <i class="fa ml-2 p-1" v-bind:class="one.icon"></i>
              </b-button>
            </div>

            <div class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('info')}}</p>
              <ul class="list-unstyled font-weight-light">
                  <li>{{$lang('s_cdt')}} {{doc.info.s_cdt}}</li>
                  <li>{{$lang('s_cr')}} {{doc.info.s_cr}}</li>
                  <li v-if="doc.info.s_mdt">{{$lang('s_mdt')}} {{doc.info.s_mdt}}</li>
                  <li v-if="doc.info.s_mr">{{$lang('s_mr')}} {{doc.info.s_mr}}</li>
              </ul>
            </div>

          </div>
        </b-row>
      </div>
    </section>

    <section>
    </section>

    <b-modal v-bind:busy="cancelationform.wait" no-close-on-backdrop id="modal-c1" :title="$lang('newcancel')" @ok.prevent="saveCancel" :ok-title="$lang('apply')" :cancel-title="$lang('cancel')">
      <CancelationItem v-bind:item=cancelationform></CancelationItem>
    </b-modal>


  </b-container>
</template>

<script>
import axios from "axios";
import CancelationItem from "./CancelationItem.vue";
export default {
  created() {
    this.openDocument();
  },
  data() {
    return {
      id: null,
      wait: true,
      error: null,
      loaded: null,
      doc: {},
      cancelationform: {
        wait: false,
        error: null,
        id: -1,
        can_type: 1,
        dbeg: null,
        dend: null,
        remark: null,
      },
      canFields: [
        {key: "s_s", label: this.$lang("state" )},
        {key: "can_type", label: this.$lang("ctype")},
        {key: "dbeg", label: this.$lang("dbeg")},
        {key: "dend", label: this.$lang("dend")},
        {key: "remark", label:this.$lang("remarkl")},
        {key: "agreeactions", label:""},
      ],

    };
  },
  computed: {
      hasActions: function() {
        return this.doc.actions.length > 0;
      },
      showCancelations: function() {
        return this.doc.cancelations;
      },
      hasCancelations: function() {
        return this.doc.cancelations && this.doc.cancelations.list && this.doc.cancelations.list.length > 0;
      },
      isEmCase: function(){
        return this.doc.emcase && this.doc.emcase.length > 0;
      },
      isSpecLeaveType: function(){
        return this.loaded && (this.doc.data.vt_raw == 70) && this.doc.data.p_spleave_ol; 
      }
  },
  components: { CancelationItem },
  methods: {
    openDocument() {
      this.wait = true;
      this.id = this.$route.params.id;
      axios
        .get("/api/GetAbsence?id=" + this.id)
        .then(resp => {
          this.wait = null;
          this.doc = resp.data.doc;
          this.loaded = true;
        })
        .catch(error => {
          this.wait = null;
          this.error = error.message;
          if (error.response.data.message) {
            this.error = error.response.data.message;
          }
        });
    },
    doAction(action) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to execute "'+action.caption+'"?')
          .then(value => {
            if (value === true) {
               this.execAction(action);
            }
          })
    },
    execAction(action) {
        let actionRequest = {docid: this.id, oid:  action.oid};
        axios.post('/api/DoActionAbsence', actionRequest) 
        .then(answ => {
          this.$bvToast.toast(answ.data.message, {title: action.caption, variant: "success"});
          this.$router.push("/aproposals")
        })
        .catch(error => {
          let actionerror = error.message;
          if (error.response && error.response.data.message) {
             actionerror = error.response.data.message;
          }
          this.$bvToast.toast(actionerror, {title: "Error", variant: "danger"});
        });        
    },
    doNewCancel(){
      this.cancelationform.wait = null;
      this.cancelationform.error = null;
      this.$bvModal.show("modal-c1");
    },
    async saveCancel(evt){
      this.cancelationform.wait = true;
      this.cancelationform.error = null;
      let form = evt.vueTarget.$refs.body.firstChild
      if (!form.checkValidity()){
         form.classList.add('was-validated');
         this.cancelationform.wait = null
         return;
      };
      var data2save = {
        proposalid: this.id,
        can_type: this.cancelationform.can_type,
        dbeg: this.cancelationform.dbeg,
        dend: this.cancelationform.dend,
        remark: this.cancelationform.remark,
      }
      axios.post('/api/AddAbsenceCancelation', data2save) 
        .then(answ => {
          this.$bvModal.hide("modal-c1");
          this.$bvToast.toast(answ.data.message, {title: "Document saved", variant: "success"});
          this.openDocument();
        })
        .catch(error => {
          this.cancelationform.wait = null;
          this.cancelationform.error = error.message;
          if (error.response.data.message) {
             this.cancelationform.error = error.response.data.message;
          }
        });
    },
    doCancelationAction(id, oid) {
       axios.post('/api/DoActionAbsenceCancelation', {docid:id, oid: oid}) 
        .then(answ => {
          this.$bvToast.toast(answ.data.message, {title: "Document saved", variant: "success"});
          this.openDocument();
        })
        .catch(error => {
          this.$bvToast.toast(answ.data.message, {title: "Error", variant: "danger"});
        });
    },
    doAskAction(quest, id, oid){
       this.$bvModal.msgBoxConfirm(this.$lang(quest), { okTitle: this.$lang('yes'), cancelTitle: this.$lang('no')})
      .then(value => {
        if (value === true) {
          this.doCancelationAction(id, oid);
        }
      });
    },
  },
  locales: {
    en: {
      aproposal: "Absence Proposal",
      details: "Details",
      actions: "Actions",
      dochistory: "Document History",
      info: "Document Information",
      atype: "Absence Type:",
      date: "Date:",
      todate: "Until Date:",
      ptype: "Period Type:",
      sabegin: "Short Absence Begin:",
      saduration: "Short Absence Duration:",
      remark: "Remark:",
      s_cdt: "Created:",
      s_cr: "Created by:",
      s_mdt: "Modified:",
      s_mr: "Modified by:",
      description: "",
      cancelations: "Cancelations",
      apply: "Apply",
      cancel: "Cancel",
      newcancel: "New Cancelation",
      state: "State",
      ctype: "Cancelation Type",
      dbeg: "Cancel From",
      dend: "Cancel Until",
      remarkl: "Remark",
      agree: "Agree",
      disagree: "Disagree",
      qagree: "Are you sure you want to agree with cancellation?",
      qdisagree: "Are you sure you want to disagree with cancellation?",
      yes: "Yes",
      no: "No",
      emcase: "Emergency Case:",
      specialleavetype: "Special Leave Type",
    },
    de: {
      aproposal: "Abwesenheitsantrag",
      details: "Einzelheiten",
      actions: "Aktionen",
      dochistory: "Dokumentenverlauf",
      info: "Dokumentinformationen",
      atype: "Abwesenheitsart:",
      date: "Datum:",
      todate: "Bis zum Datum:",
      ptype: "Periodentyp:",
      sabegin: "Kurze Abwesenheit ab:",
      saduration: "Kurze Abwesenheitsdauer:",
      remark: "Bemerkungen:",
      s_cdt: "Erstellt:",
      s_cr: "Erstellt von:",
      s_mdt: "Geändert:",
      s_mr: "Geändert von:",
      description: "",
      cancelations: "Stornierungen",
      apply: "Beantragen",
      cancel: "Abbrechen",
      newcancel: "Neuen Abwesenheit Stornierung",
      state: "Zustand",
      ctype: "Stornierung Art",
      dbeg: "Von Datum",
      dend: "Bis Datum",
      remarkl: "Bemerkungen",
      agree: "Zustimmen",
      disagree: "Zustimmen nicht",
      qagree: "Sind Sie sicher, dass Sie der Stornierung zustimmen möchten?",
      qdisagree: "Sind Sie sicher, dass Sie der Stornierung nicht zustimmen möchten?",
      yes: "Ya",
      no: "Nein",
      emcase: "Notfall:",
      specialleavetype: "Art des Sonderurlaubs",
    },
    ru:  {
      aproposal: "Запись об отсутствии",
      details: "Подробно",
      actions: "Действия",
      dochistory: "История обработки",
      info: "Информация о документе",
      atype: "Вид отсутствия:",
      date: "Дата:",
      todate: "До даты:",
      ptype: "Период:",
      sabegin: "Короткое отсутствие с:",
      saduration: "Длительность короткого отсутствия:",
      remark: "Примечания:", 
      s_cdt: "Создан:",
      s_cr: "Кем создан:",
      s_mdt: "Изменен:",
      s_mr: "Кем изменен:",
      description: "",
      cancelations: "Отмена записи об отсутствии",
      apply: "На утверждение",
      cancel: "Отмена",
      newcancel: "Новый запрос на отмену",
      state: "Состояние",
      ctype: "Тип отмены",
      dbeg: "Отмена с",
      dend: "Отмена по",
      remarkl: "Примечания",
      agree: "Подтвердить",
      disagree: "Не подтвердить",
      qagree: "Вы уверены что согласны с отменой?",
      qdisagree: "Вы уверены что не согласны с отменой?",
      yes: "Да",
      no: "Нет",
      emcase: "Непредвиденные обстоятельства:",
      specialleavetype: "Тип специального отпуска",
    },
    pl:  {
      aproposal: "Rekord nieobecności",
      details: "Detale",
      actions: "Działania",
      dochistory: "Historia przetwarzania",
      info: "Informacje o dokumencie",
      atype: "Typ:",
      date: "Data:",
      todate: "Aktualny:",
      ptype: "Okres nieobecności:",
      sabegin: "Godzina rozpoczęcia nieobecności:",
      saduration: "Długość nieobecności:",
      remark: "Uwagi:", 
      s_cdt: "Stworzone:",
      s_cr: "Stworzone przez:",
      s_mdt: "Zmodyfikowany:",
      s_mr: "Modyfikowane przezda:",
      description: "",
      cancelations: "Anulowanie wpisu nieobecności",
      apply: "Prośba o zatwierdzenie",
      cancel: "Anulować",
      newcancel: "Nowe anulowanie rekordu nieobecności",
      state: "Stan",
      ctype: "Opcja anulowania",
      dbeg: "Anuluj od daty",
      dend: "Anuluj przed datą",
      remarkl: "Uwagi",
      agree: "Zgadzam się na anulowanie",
      disagree: "Nie zgadzam się na anulowanie",
      qagree: "Czy na pewno zgadzasz się na anulowanie?",
      qdisagree: "Czy na pewno nie zgadzasz się na anulowanie?",
      yes: "Tak",
      no: "Nie",
      emcase: "Niewidoczne okoliczności:",
      specialleavetype: "Rodzaj urlopu specjalnego",
    }
  },
};
</script>

<style>
.sectionhdr {
  margin-bottom: 2rem;
  font-size: 12px;
  font-weight: 600;
}
.formgroup {
  padding: 24px 0;
  background-color: #fff;
  min-height: 200px;
}
.toolbox {
  background-color: #fafafa;
  min-height: 350px;
}
ul.timeline {
    list-style-type: none;
    position: relative;
}
ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}
ul.timeline > li {
    margin: 20px 0;
    padding-left: 20px;
}
ul.timeline > li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid ;
    border-color: inherit;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}
.state {
  white-space: nowrap;
} 
.first-inverted{
  background-color: #606b75;
  color: white;
  font-weight: bold;
}
thead.thead-dark{
  border: 1px solid #606b75;
}
.actionbutton {
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/EditAproposalItem.vue